// migration-allow(family-importers): this host supplies localized countries to the moved logged-out title
import { useLocalizedCountries } from '@/hooks/useLocalizedCountries';
import { useUrlFilters } from '@/hooks/useUrlFilters';
import { LoggedOutStateTitle, useQueryCommunityTemplates } from '@heidi/templates';
import type { ComponentProps } from 'react';

export function LoggedOutStateTitleHost({
  ...props
}: Omit<
  ComponentProps<typeof LoggedOutStateTitle>,
  'localizedCountries' | 'getLocalizedNameFromEnglish' | 'total'
>) {
  const { localizedCountries, getLocalizedNameFromEnglish } = useLocalizedCountries();
  const { page, sort, location, specialty, category, search, specialties } =
    useUrlFilters();
  const { data } = useQueryCommunityTemplates({
    page,
    sort,
    location,
    specialty,
    category,
    search,
    specialties,
  });

  return (
    <LoggedOutStateTitle
      {...props}
      total={data?.total}
      localizedCountries={localizedCountries}
      getLocalizedNameFromEnglish={getLocalizedNameFromEnglish}
    />
  );
}
